import PageMeta from "../../components/common/PageMeta";
import { CHANGELOG_CONFIG } from "../../data/changeLog";
import { formatDate } from "../../utils/common/format";

export default function Changelog() {
  return (
    <>
      <PageMeta
        title="更新履歴"
        description="各バージョンの変更内容や修正内容を確認できます。"
        path="/changelog"
        breadcrumbs={[
          { name: "TOP", path: "/" },
          { name: "更新履歴", path: "/changelog" },
        ]}
      />
      <div className="mx-auto mb-8">
        <div className="flex justify-between items-center flex-wrap mb-8 border-b border-b-2 border-primary-500 pb-2">
          <h1 className="text-2xl font-bold text-primary-500">
            更新履歴
          </h1>
        </div>
        <div className="p-8 bg-base-50 rounded-3xl">
          <ul className="space-y-8">
            {CHANGELOG_CONFIG.slice().reverse().map((entry) => (
              <li key={entry.version} className="border-l-2 border-primary-500 pl-4">
                <div className="flex items-baseline gap-3 mb-2">
                  <span className="text-sm font-bold text-primary-500">
                    v{entry.version}
                  </span>
                  <span className="text-xs text-primary-500/60">
                    {formatDate(entry.date)}
                  </span>
                </div>
                <ul className="space-y-1">
                  {entry.comments.map((comment, i) => (
                    <li key={i} className="text-sm text-gray-800 before:content-['・'] before:text-primary-500">
                      {comment}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
